﻿import ApplicationsBusinessInfo from './ApplicationsBusinessInfo';
import ApplicationsPersonalInfo from './ApplicationsPersonalInfo';
import ApplicationsRebates from './ApplicationsRebates';
import ApplicationsResidence from './ApplicationsResidence';

export default class ApplicationsDataAnswered {
	constructor(init) {
		//FROM QUOTE
		this.dealTypes = []; // Possible Values: cash, finance, lease
		this.requestedInaccurateQuote = null;
		this.garagedAddressOutsideUS = null;
		this.garagedAddressSameAsResidence = null;
		this.garagedAddress = new ApplicationsResidence();
		this.personalInfo = new ApplicationsPersonalInfo({});
		this.rebates = new ApplicationsRebates({});
		this.isBusiness = null;
		this.businessInfo = new ApplicationsBusinessInfo();

		if (init) {
			//FROM QUOTE
			this.dealTypes = init.dealTypes;
			this.requestedInaccurateQuote = init.requestedInaccurateQuote;
			this.garagedAddressOutsideUS = init.garagedAddressOutsideUS;
			this.garagedAddressSameAsResidence = init.garagedAddressSameAsResidence;
			this.garagedAddress = new ApplicationsResidence(init.garagedAddress);
			this.personalInfo = new ApplicationsPersonalInfo(init.personalInfo);
			this.rebates = new ApplicationsRebates(init.rebates);
			this.isBusiness = init.isBusiness;
			this.businessInfo = new ApplicationsBusinessInfo(init.businessInfo);
		}
	}
}
